export default "__VITE_ASSET__SsVrVAbu__"